goog.provide('el8.app.shared.documentImageRenderer');

goog.require('el8.uiwidget.ImageFeed');
goog.require('el8.template.render.reportFeedItem');


/**
 * This method takes a document that supports images, specs of how the images should be 
 * rendered, and a container to render the images in.  It then renders the images in a 
 * paged feed, so that we aren't showing arbitrarily many images.
 *
 * TODO: Still uses the reportFeedItem template; should genericize beyond reports
 */

el8.app.shared.documentImageRenderer = function(doc, imageSpec, container) {

    var imageHeight = imageSpec.imageHeight;
    var imageWidth = imageSpec.imageWidth;
    var imageClass = imageSpec.imageClass || 'thumbnail';
    var imageItemWrapClass = imageSpec.imageItemWrapClass || '.image-item-wrap';

    var feed = new el8.uiwidget.ImageFeed({
        container: container,
        name: 'report-'+doc.getId(),
        moreTrigger: '#report-'+doc.getId()+'-images-more-btn',
        emptyMsg: 'There are no images associated with this document.',
        rendererFn: function() {
            return function(item, feedId) {
                var url = item['id'];
                if (imageClass === 'filer') {
                    url = url.replace('size=preview', 'size=filer');
                }
                return el8.template.render.reportFeedItem.image({
                    url: url,
                    reportId: item['docId'],
                    feedId: feedId
                });
            };
        },
        pageSize: 10,
        skeletonFn: function(spec) {
            spec = spec || {};
            spec.reportId = doc.getId();
            return el8.template.render.reportFeedItem.imageFeed(spec);
        },
        indexedImageFn: function(url) {
            return {
                id: url,
                docId: doc.getId()
            };
        },
        /* Image opts */
        imageWidth: imageWidth,
        imageHeight: imageHeight,
        imageClass: imageClass || 'thumbnail',
        imageItemWrapClass: imageItemWrapClass,
        fid: doc.getFeedItemId(),
        zoomable: true
    });

    feed.loadImages(doc.getImages());

    return feed;
};


